import { useMemo } from "react";

import { useAdoptedMix } from "@pages/mmm/hooks/use-adopted-mix";
import { useBudgetMixes } from "@pages/mmm/hooks/use-budget-mixes";

export const useAdoptedBudgetMix = () => {
  const [budgetMixes] = useBudgetMixes();
  const [adoptedMix] = useAdoptedMix();

  const { mix, adoptedKpiName } = useMemo(() => {
    const bmMix = budgetMixes.find(({ id }) => id === adoptedMix?.id) ?? null;
    const bmAdoptedKpiName = bmMix?.client_setting_kpi || bmMix?.data?.kpi_name;
    return { mix: bmMix, adoptedKpiName: bmAdoptedKpiName };
  }, [budgetMixes, adoptedMix]);

  const totalAdoptedBudgetedSpend = useMemo(() => {
    if (!mix) {
      return 0;
    }
    const totalBudgeted = mix.data.weekly_data.reduce(
      (budgeted, week) => budgeted + week.summary_data.spend,
      0,
    );
    return totalBudgeted;
  }, [mix]);

  return { adoptedBudgetMix: mix, adoptedKpiName, totalAdoptedBudgetedSpend };
};
